var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 108,
    viewBox: "0 0 107 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "08rig4gzja",
    x1: "116.483%",
    x2: "26.693%",
    y1: "-9.481%",
    y2: "66.971%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFAE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#08rig4gzja)",
    d: "M106.535 49L47.875 107.66 0 40.959 40.875 0z",
    opacity: 0.4,
    transform: "translate(-1110 -1222) translate(1110 1222)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F5EB",
    d: "M41 1H106V50H41z",
    transform: "translate(-1110 -1222) translate(1110 1222)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAE00",
    fillRule: "nonzero",
    d: "M40.596 0l-.047.001c-.306.016-.549.27-.549.576v48.612l.001.047c.015.305.27.546.579.546h32.136l.152 12.92-.653.008-12.45.136-.047.001c-.307.016-.55.269-.55.576 0 .319.26.577.58.577h27.367l.047-.001c.308-.015.55-.268.55-.576 0-.319-.259-.576-.58-.576H74.164l-.152-12.926.657-.002 31.615-.137h.047c.308-.016.549-.269.549-.577V.593l-.001-.046c-.015-.305-.27-.547-.579-.547H40.596zm65.125 1.153V48.63H41.159V1.153h64.562zM63.345 30.476h-14.18c-.243 0-.439.195-.439.436v7.619c0 .24.196.435.438.435h14.18c.243 0 .439-.195.439-.435v-7.62c0-.24-.196-.435-.438-.435zM83.31 21.02c-.091.152-.117.335-.071.505l4.003 14.93c.094.348.453.555.804.461.081-.022.158-.059.225-.109l4.309-3.228 3.565 4.71c.146.193.422.231.617.085.193-.144.231-.415.087-.607l-3.568-4.713 4.305-3.224c.29-.218.349-.627.132-.916-.05-.068-.114-.125-.187-.168l-13.319-7.952c-.311-.186-.716-.085-.902.226zM62.579 31.673v6.096H49.93v-6.096h12.65zm21.647-9.856l12.582 7.512-8.8 6.592-3.782-14.104zm-34.774-2.225h-.053c-.387.018-.673.293-.673.599 0 .317.307.598.711.598H63.11c.387-.018.673-.293.673-.598 0-.318-.307-.6-.711-.6h-13.62zm0-5.442h-.053c-.387.018-.673.293-.673.598 0 .318.307.599.711.599h24.581c.387-.018.672-.293.672-.599 0-.317-.306-.598-.71-.598H49.452zM73.98 8.708H49.399c-.387.018-.673.293-.673.598 0 .317.307.599.711.599h24.528l.053-.001c.387-.017.672-.292.672-.598 0-.317-.306-.598-.71-.598z",
    transform: "translate(-1110 -1222) translate(1110 1222)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceicon3);
export default __webpack_public_path__ + "static/media/serviceicon3.5b549258849cca16517bef9dea4be7e7.svg";
export { ForwardRef as ReactComponent };